// Taken from https://fettblog.eu/typescript-assertion-signatures/
export default function defineProperty(obj, prop, val) {
    Object.defineProperty(obj, prop, val);
};
